import { EventHighlightsReturn, Highlights, HighlightsReturn, SmoothHighlightsReturn } from './types';
import { fetchAllHighlights, fetchEventHighlights } from './services';

import { QUERY_KEYS_NO_FETCHING as QUERY_KEYS } from 'utils/constants';
import { getDays } from './utils';
import { useQuery } from '@tanstack/react-query';

export function useHighlights(id: string, smoothData: true): SmoothHighlightsReturn;
export function useHighlights(id: string, smoothData?: false): EventHighlightsReturn;
export function useHighlights(): HighlightsReturn;
export function useHighlights(id?: string, smoothData?: boolean) {
	const { data: highlights, isLoading: isAllLoading } = useQuery({
		queryKey: [QUERY_KEYS.HIGHLIGHTS],
		queryFn: fetchAllHighlights,
		enabled: id === undefined,
	});

	const { data: eventHighlights, isLoading: isEventLoading } = useQuery({
		queryKey: [QUERY_KEYS.EVENT_HIGHLIGHTS, id],
		queryFn: (): Promise<Highlights<string>> => fetchEventHighlights(id),
		enabled: Boolean(id),
		select: (data) => (smoothData ? (getDays(data) as Highlights<Date>) : data),
	});

	return { highlights, eventHighlights, isLoading: id ? isEventLoading : isAllLoading };
}
